<template>
  <div class="pg-root">
    <div class="pg-grid">
      <div class="pg-card">
        <div class="pg-card-header">
          <h3 class="pg-card-title">Consumo por restaurante</h3>
          <span class="pg-card-sub">% de faturação</span>
        </div>
        <div
          v-if="
            restaurantes.chartData.labels &&
            restaurantes.chartData.labels.length
          "
        >
          <doughnut-chart
            id="pie-perfil-restaurantes"
            :height="300"
            :chart-data="restaurantes.chartData"
            :extra-options="restaurantes.extraOptions"
          />
        </div>
        <div v-else class="pg-empty">Sem dados a mostrar</div>
      </div>

      <div class="pg-card">
        <div class="pg-card-header">
          <h3 class="pg-card-title">Consumo por período da refeição</h3>
          <span class="pg-card-sub">% de faturação</span>
        </div>
        <div
          v-if="refeicoes.chartData.labels && refeicoes.chartData.labels.length"
        >
          <doughnut-chart
            id="pie-perfil-refeicoes"
            :height="300"
            :chart-data="refeicoes.chartData"
            :extra-options="refeicoes.extraOptions"
          />
        </div>
        <div v-else class="pg-empty">Sem dados a mostrar</div>
      </div>
    </div>
  </div>
</template>

<script>
  import DoughnutChart from "@/components/Charts/DoughnutChart";

  export default {
    name: "PerfilGraficos",
    components: { DoughnutChart },
    props: {
      restaurantes: {
        type: Object,
        default: () => ({
          chartData: { labels: [], datasets: [] },
          extraOptions: {},
        }),
      },
      refeicoes: {
        type: Object,
        default: () => ({
          chartData: { labels: [], datasets: [] },
          extraOptions: {},
        }),
      },
    },
  };
</script>

<style scoped>
  .pg-root {
    margin-bottom: 16px;
  }
  .pg-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  .pg-card {
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  }
  .pg-card-header {
    padding: 14px 20px;
    border-bottom: 1px solid #f5f2ef;
  }
  .pg-card-title {
    font-size: 14px;
    font-weight: 700;
    color: #1a1210;
    margin: 0 0 2px;
  }
  .pg-card-sub {
    font-size: 12px;
    color: #b0a8a0;
  }
  .pg-empty {
    text-align: center;
    padding: 48px 20px;
    color: #b0a8a0;
    font-size: 13.5px;
    font-style: italic;
  }

  @media (max-width: 768px) {
    .pg-grid {
      grid-template-columns: 1fr;
    }
  }
</style>
